module.exports = __webpack_public_path__ + "img/p-15-2.4cc26601.jpg";